export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-480-5a9fee199e8512185ca5b3fdc7d6cf01.webp";